import type { LucideProps } from "lucide-react";
import { DynamicIcon } from "lucide-react/dynamic";
import { Suspense } from "react";

import { resolveLucideIconName } from "./utils";

interface IconComponentProps extends Omit<LucideProps, "name"> {
  /** 后端 / 配置中的图标名，如 Store、BarChart3 */
  name?: string | null;
  /** 主图标无效或未提供时的回退图标名 */
  fallbackName?: string;
}

/**
 * 按名称动态渲染 Lucide 图标
 * 适用于菜单、权限树等后端配置驱动的场景
 */
export const IconComponent = ({ name, fallbackName, ...props }: IconComponentProps) => {
  // 优先使用主图标名，无效时尝试回退名
  const iconName = resolveLucideIconName(name) ?? resolveLucideIconName(fallbackName);
  if (!iconName) return null;
  return (
    <Suspense fallback={<span className={props.className} aria-hidden />}>
      <DynamicIcon name={iconName} {...props} />
    </Suspense>
  );
};
